import { safeJsonParse } from '../../../functions/safeJsonParse';

export const findCart = (list, restaurantId) => {
  if (!Array.isArray(list) && !list.length && !restaurantId) return [];

  const findRestaurant = list.find((elem) => elem.restaurant_id == restaurantId);
  return Array.isArray(findRestaurant.cart_items) ? findRestaurant.cart_items : [];
};

export const findAddonVariation = (cart, item) => {
  if (!Array.isArray(cart) && !item.item_id) return { addOnToRemove: '', variationTORemove: '' };
  let findItem, addOnToRemove, variationTORemove;
  const id = item.id || item.item_id;
  if (!item.addon) {
    findItem = cart.find((elem) => elem.item_id == id);
    addOnToRemove = findItem?.addon || findItem?.addons;
    addOnToRemove = Array.isArray(addOnToRemove)
      ? addOnToRemove.map((elem) => ({ id: elem.id, qty: elem.qty }))
      : addOnToRemove;
      variationTORemove = safeJsonParse(item?.new_variation || findItem?.new_variation) || null;
    // (typeof findItem?.new_variation == 'string' && JSON.parse(findItem?.new_variation)) ||
    // (Array.isArray(findItem?.new_variation) && findItem?.new_variation) ||
    // null;
  } else {
    addOnToRemove = item?.addon || item.addons;
    variationTORemove = safeJsonParse(item?.new_variation) || null;
    // (typeof item?.new_variation == 'string' && JSON.parse(item?.new_variation)) ||
    // (Array.isArray(item?.new_variation) && item?.new_variation) ||
    // null;
  }

  return { addOnToRemove, variationTORemove };
};
